import { ajax } from 'rxjs/ajax';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

// адрес  бэкенда - сервер на комп-е
const API_URL = 'http://localhost:7070/api';

/**
 * Получает непрочитанные сообщения с сервера
 * @returns {Observable} Observable с массивом сообщений
 */
export function fetchUnreadMessages() {
    // Возврат observable
    return ajax.getJSON(`${API_URL}/messages/unread`).pipe(
        map(response => response.messages || []),    //// [{ id: 1, ... }, { id: 2, ... }]
        catchError(error => {
            console.error('Ошибка при запросе сообщений:', error);
            // При ошибке возвращаем пустой массив (как будто нет новых сообщений)
            return of([]);
        })
    );
}

// При ошибке возвращаем пустой массив (задание: 
// "преобразовывайте ошибку так, чтобы это было аналогично отсутствию новых сообщений")
// ajax - инструмент для HTTP-запросов (как fetch, но для RxJS)
// map - преобразователь данных
// catchError - ловушка для ошибок
// of - создатель observable(поток)из простых значений